import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PageInfo } from 'src/app/core/models/page-info';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HubLabelSetupService {

  private baseUrl: string = `${environment.logisticsApiUrl}/hubLabelSetup`
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient
  ) { }

  getHubLabelSetups(queryCondition: any, pageInfo: PageInfo, sortInfo: any): Observable<any> {
    const getRequestData = {
      "orgId": queryCondition.orgId,
      "custSku": queryCondition.custSku,
      "hubVendorCode": queryCondition.hubVendorCode,
      "labelKey": queryCondition.labelKey,
      "pageIndex": pageInfo.pageIndex,
      "pageSize": pageInfo.pageSize,
      "sortInfo": {
        "direction": sortInfo.direction,
        "property": sortInfo.property
      }
    }
    return this.http.post<any>(this.baseUrl, getRequestData, this.httpOptions)
  }

  saveChanges(savedData: any): Observable<any> {
    return this.http.put<any>(this.baseUrl, savedData, this.httpOptions);
  }
}
